import { createIcon } from '@chakra-ui/react';

export const ContactBoldIcon = createIcon({
  displayName: 'ContactBoldIcon',
  path: (
    <>
      <svg viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.42002 29.62H6C2.96 29.62 0.5 27.16 0.5 24.12V14.98C0.5 11.94 2.96 9.47998 6 9.47998H9.42002C12.46 9.47998 14.92 11.94 14.92 14.98V24.12C14.92 27.16 12.46 29.62 9.42002 29.62ZM6 12.48C4.62 12.48 3.5 13.6 3.5 14.98V24.12C3.5 25.5 4.62 26.62 6 26.62H9.42002C10.8 26.62 11.92 25.5 11.92 24.12V14.98C11.92 13.6 10.8 12.48 9.42002 12.48H6Z"
          fill="currentColor"
        />
        <path
          d="M34.0007 0.5H15.7207C11.3207 0.5 7.7207 4.1 7.7207 8.5V10.98H9.4207C11.6207 10.98 13.4207 12.78 13.4207 14.98V24.12C13.4207 26.32 11.6207 28.12 9.4207 28.12H7.7207V32.5C7.7207 36.9 11.3207 40.5 15.7207 40.5H34.0007C38.4007 40.5 42.0007 36.9 42.0007 32.5V8.5C42.0007 4.1 38.4007 0.5 34.0007 0.5ZM27.4007 9C30.4207 9 32.8807 11.46 32.8807 14.5C32.8807 17.52 30.4207 19.98 27.4007 19.98C24.3807 19.98 21.9207 17.52 21.9207 14.5C21.9207 11.46 24.3807 9 27.4007 9ZM35.4007 32C34.5807 32 33.9007 31.32 33.9007 30.5C33.9007 27.74 30.9807 25.48 27.4007 25.48C23.8207 25.48 20.9007 27.72 20.9007 30.5C20.9007 31.32 20.2207 32 19.4007 32C18.5807 32 17.9007 31.32 17.9007 30.5C17.9007 26.08 22.1607 22.48 27.4007 22.48C32.6407 22.48 36.9007 26.08 36.9007 30.5C36.9007 31.32 36.2207 32 35.4007 32Z"
          fill="currentColor"
        />
        <path
          d="M27.3999 16.98C28.7799 16.98 29.8799 15.86 29.8799 14.5C29.8799 13.12 28.7599 12 27.3999 12C26.0399 12 24.9199 13.12 24.9199 14.5C24.9199 15.86 26.0199 16.98 27.3999 16.98Z"
          fill="currentColor"
        />
      </svg>
    </>
  ),
});
